import { range } from "@punks/core"
import React from "react"
import CustomSkeleton from "../../../../../ui/atoms/Skeleton"

const FiltersSidebarSkeleton = () => {
  return (
    <>
      <div className="mb-4">
        <CustomSkeleton variant="rect" height={200} />
      </div>
      {range(0, 6).map((x) => (
        <div className="mb-2" key={x}>
          <CustomSkeleton variant="text" />
        </div>
      ))}
    </>
  )
}

export default FiltersSidebarSkeleton
